import React from 'react';
import { motion } from 'framer-motion';

const menuItems = [
  { id: 'audio', icon: '🎙️', title: 'Sesli Anı', desc: 'Sesinizle bir anı bırakın' },
  { id: 'text', icon: '✍️', title: 'Yazılı Anı & İmza', desc: 'Mesajınızı ve imzanızı bırakın' },
  { id: 'media', icon: '📸', title: 'Fotoğraf & Video', desc: 'Anlarınızı paylaşın' },
  { id: 'location', icon: '📍', title: 'Mekan & Yol Tarifi', desc: 'Düğün alanına navigasyon' },
];

export default function Hero({ onNavigate }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen min-h-[100dvh] px-6 py-12">
      {/* Üst dekoratif çizgi */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="w-24 h-px bg-gold-500 mb-8"
      />

      {/* Alyans dekorasyonu */}
      <motion.div
        initial={{ opacity: 0, scale: 0.6, rotate: -10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 1, type: 'spring', bounce: 0.4 }}
        className="mb-4 relative"
      >
        <div className="flex items-center -space-x-3">
          <div className="w-10 h-10 rounded-full border-[3px] border-gold-500 bg-transparent" />
          <div className="w-10 h-10 rounded-full border-[3px] border-gold-400 bg-transparent" />
        </div>
        <motion.div
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ repeat: Infinity, duration: 3, ease: 'easeInOut' }}
          className="absolute -top-1 left-1/2 -translate-x-1/2 text-gold-500 text-[10px]"
        >
          ✦
        </motion.div>
      </motion.div>

      {/* Başlık */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="font-playfair text-4xl sm:text-5xl text-sage-800 text-center leading-tight"
      >
        Bengisu
        <img src={process.env.PUBLIC_URL + '/kalp.png'} alt="kalp" className="inline-block w-8 h-8 mx-2 align-middle object-contain" />
        Batuhan
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="font-playfair text-lg text-sage-600 tracking-widest mt-2"
      >
        TÜFEKÇİ
      </motion.p>

      {/* Tarih ve saat */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="mt-6 text-center"
      >
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/60 backdrop-blur-sm rounded-full border border-gold-300/40">
          <span className="text-sage-700 font-medium text-sm">17 Mayıs 2026</span>
          <span className="w-1 h-1 bg-gold-500 rounded-full" />
          <span className="text-sage-700 font-medium text-sm">15:00 — 18:00</span>
        </div>
      </motion.div>

      {/* Alt başlık */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9 }}
        className="mt-4 text-sage-500 text-sm tracking-wide"
      >
        Dijital Anı Merkezi
      </motion.p>

      {/* Altın çizgi */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.8, delay: 1 }}
        className="w-16 h-px bg-gold-400 mt-6 mb-10"
      />

      {/* Menü kartları */}
      <div className="w-full max-w-sm space-y-3">
        {menuItems.map((item, i) => (
          <motion.button
            key={item.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.1 + i * 0.15 }}
            onClick={() => onNavigate(item.id)}
            className="w-full flex items-center gap-4 p-4 bg-white/70 backdrop-blur-sm rounded-2xl
                       border border-sage-200/50 hover:border-gold-400/60
                       transition-all duration-300 hover:shadow-lg hover:shadow-sage-200/30
                       active:scale-[0.98] group"
          >
            <span className="text-2xl group-hover:scale-110 transition-transform">{item.icon}</span>
            <div className="text-left">
              <h3 className="font-playfair text-sage-800 font-semibold">{item.title}</h3>
              <p className="text-sage-500 text-xs mt-0.5">{item.desc}</p>
            </div>
            <svg className="ml-auto w-5 h-5 text-sage-300 group-hover:text-gold-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </motion.button>
        ))}
      </div>

      {/* Alt not */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
        className="mt-10 text-sage-400 text-xs text-center"
      >
        Bu özel gününüzde yanımızdasınız, teşekkür ederiz ♡
      </motion.p>
    </div>
  );
}
